export const NUMBER_OF_TEAMS_PER_PAGE = 25

export enum TeamRole {
  VIEWER = 'team_role:viewer',
  MEMBER = 'team_role:member',
  ADMIN = 'team_role:admin'
}

export enum TeamsOrderBy {
  NameAsc = 'teamName',
  NameDsc = '-teamName',
  MemberCountAsc = 'memberCount',
  MemberCountDsc = '-memberCount',
  SubteamCountAsc = 'directChildrenCount',
  SubteamCountDsc = '-directChildrenCount'
}

export enum TeamMembersOrderBy {
  NameAsc = 'name',
  NameDsc = '-name',
  RoleAsc = 'role',
  RoleDsc = '-role'
}
